module.exports = __webpack_public_path__ + "img/tournament_nav.e1f9f253.svg";